var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfMenuCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.906,
    height: 22.906,
    viewBox: "0 0 22.906 22.906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/circle-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M20.0414 11.4517C20.0414 6.70772 16.1957 2.86196 11.4517 2.86196C6.70772 2.86196 2.86196 6.70772 2.86196 11.4517C2.86196 16.1957 6.70772 20.0414 11.4517 20.0414C16.1957 20.0414 20.0414 16.1957 20.0414 11.4517ZM13.6401 7.91365C14.0129 7.54093 14.617 7.54093 14.9897 7.91365C15.3625 8.28637 15.3625 8.89053 14.9897 9.26325L12.8013 11.4517L14.9897 13.6401C15.3625 14.0129 15.3625 14.617 14.9897 14.9897C14.617 15.3625 14.0129 15.3625 13.6401 14.9897L11.4517 12.8013L9.26325 14.9897C8.89053 15.3625 8.28637 15.3625 7.91365 14.9897C7.54093 14.617 7.54093 14.0129 7.91365 13.6401L10.1021 11.4517L7.91365 9.26325C7.54093 8.89053 7.54093 8.28637 7.91365 7.91365C8.28637 7.54093 8.89053 7.54093 9.26325 7.91365L11.4517 10.1021L13.6401 7.91365ZM21.9503 11.4517C21.9503 17.2499 17.2499 21.9503 11.4517 21.9503C5.6535 21.9503 0.953125 17.2499 0.953125 11.4517C0.953125 5.6535 5.6535 0.953125 11.4517 0.953125C17.2499 0.953125 21.9503 5.6535 21.9503 11.4517Z",
    fill: "url(#paint0_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 0.953125,
    y1: 11.4517,
    x2: 21.9503,
    y2: 11.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfMenuCancel);
export default __webpack_public_path__ + "static/media/cf-menu-cancel.4f14c18770cb27cb72b040ffa8255a96.svg";
export { ForwardRef as ReactComponent };